@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.assignment-modal {
  width: 500px;
}

.modal-body {
  padding: 15px;
  height: 55px;
  overflow: hidden;
  button:hover {
    svg {
      fill: @assignment-modal--fill-color;
    }
  }
}

.modal-footer {
  height: initial;
  button:nth-child(even) {
    margin-left: 10px;
  }
}
